import Modal from 'react-bootstrap/Modal'
import {Field, Form, Formik, useFormik} from "formik";
import {TextField} from "../../components/common/TextField/TextField";
import React, {useEffect, useState} from "react";
import ShowNotification from "../../components/common/Notification/ShowNotification";

const AddDataModal = ({show,groups,productType,addProductTypeTh,setIsCreateProductType,...props}) => {
    debugger
     
    const [submitClicked,setSubmitClicked]=useState(false)
  
    let [showModal, setShowModal] =useState(show)
    const handleClose=()=>{
        setShowModal(false)
        setIsCreateProductType(false)
    }
 
    useEffect(()=>{
        if(show) setShowModal(true)
        else setShowModal(false)
    },[show])

    let productInstance={
        name: "name 3",
        status: 1,
    }

    return(<Formik
        initialValues={{
            name: "",
            status: 1,
        }}
        onSubmit={(formValues)=> {
            if(submitClicked){
                console.log();
                console.log(formValues);

                debugger
                productInstance.name=formValues.name
                productInstance.status=1
                // console.log(productInstance)
                addProductTypeTh(productInstance);
                setIsCreateProductType(false)
            }

        }}
    >
        {props => (
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Məhsul Növü əlavə et</Modal.Title>
                </Modal.Header>
                <Form>
                    <Modal.Body>
                        <TextField label="Məhsul Növü Adı"
                                   name="name"
                                   type="text"
                                   enableLabel='true'                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="reset"
                                className="btn btn-default"
                                onClick={handleClose}
                                data-dismiss="modal">Bağla</button>
                        <button type="submit"
                                onClick={()=>{
                                    setSubmitClicked(true)
                                }}
                                className="btn btn-primary">Yadda Saxla</button>
                    </Modal.Footer>
                </Form>
            </Modal>

        )}
    </Formik>)
}

export default AddDataModal
